// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3WmwQ","navText":"Navbar_navText__2Sn_V","navLogo":"Navbar_navLogo__2AduC","imgLogo":"Navbar_imgLogo__1W0vK"};